<template>
  <div>
    <div v-if="loader" style="position: relative; width: 100vw; height: 100vh">
      <v-progress-circular
        style="
          position: abolute;
          z-index: 999;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -100%);
        "
        size="100"
        indeterminate
        color="important"
      >
      </v-progress-circular>
    </div>
    <div v-else class="absolute-content">
      <!-- map -->
      <!-- map -->
      <!-- map -->

      <div id="google_map">
        <GmapMap
          :center="{
            lat: 40.12641,
            lng: 23.54958,
          }"
          :zoom="8"
          :options="mapOptions"
          class="googleMap"
          ref="mapRef"
        >
          <div>
            <gmap-custom-marker
              v-for="tour in tours"
              :key="tour.id"
              :marker="{
                lat: tour.latitude,
                lng: tour.longitude,
              }"
              :zIndex="2"
              class="mt-2"
            >
              <button>
                <img
                  v-if="tour.tour && tours_show"
                  src="@/assets/icons/map/Tour POI Icon.svg"
                  style="height: 32px; width: auto"
                  @click="onTourClick(tour)"
                />
                <img
                  v-if="!tour.tour && colonies_show"
                  src="@/assets/icons/map/Colony POI Icon.svg"
                  style="height: 32px; width: auto"
                  @click="onTourClick(tour)"
                />
              </button>
            </gmap-custom-marker>
          </div>

          <gmap-custom-marker
            :marker="{
              lat: location.latitude,
              lng: location.longitude,
            }"
            :zIndex="1"
          >
            <button>
              <transition name="fade">
                <img
                  src="@/assets/icons/map/user-location.svg"
                  style="height: 32px; width: auto"
                />
              </transition>
            </button>
          </gmap-custom-marker>

          <!-- <gmap-custom-marker
          :marker="{ lat: location.latitude, lng: location.longitude }"
          v-if="hasLocation"
        >
          <v-icon
            color="blue"
            class="rounded-circle pulse-button"
            size="15"
            >mdi-circle</v-icon
          >
        </gmap-custom-marker> -->
        </GmapMap>
      </div>

      <transition name="fadeInLeft">
        <div class="d-flex flex-column align-end" v-if="!dialog">
          <button @click="toggleColonies">
            <transition name="fade">
              <div
                :style="control_1"
                v-if="colonies_show"
                class="btn_background white--text py-4 d-flex align-center justify-space-between"
                style="
                  text-align: center;
                  height: 35px;
                  width: auto;
                  z-index: 100;
                  row-gap: 8px;
                  position: absolute;
                  top: 20px;
                  right: 11px;
                  border-radius: 18px;
                  font-size: 16px;
                  width: 150px;
                "
              >
                <span class="pl-4 mr-8"> {{ $t("buttons.colonies") }} </span>

                <img
                  src="@/assets/icons/map/Colonies Button Closed.png"
                  style="width: auto; height: 28px"
                  class="mr-1"
                />
              </div>
            </transition>

            <transition name="fade">
              <img
                :style="control_1"
                v-if="!colonies_show"
                src="@/assets/icons/map/Colonies Button Closed.png"
                style="
                  height: 33px;
                  width: auto;
                  z-index: 100;
                  row-gap: 8px;
                  position: absolute;
                  top: 20px;
                  right: 13.5px;
                  border-radius: 20px;
                  border: 2.5px solid #575b4d;
                "
              />
            </transition>
          </button>

          <button @click="toggleTours">
            <transition name="fade">
              <div
                :style="control_2"
                v-if="tours_show"
                class="important white--text py-4 d-flex align-center justify-space-between"
                style="
                  text-align: center;
                  height: 35px;
                  width: auto;
                  z-index: 100;
                  row-gap: 8px;
                  position: absolute;
                  top: 66px;
                  right: 11px;
                  border-radius: 18px;
                  font-size: 16px;
                  width: 150px;
                "
              >
                <span class="pl-4 mr-4"> {{ $t("buttons.tours") }} </span>

                <img
                  src="@/assets/icons/map/Tour Button Closed.svg"
                  style="width: auto; height: 28px"
                  class="mr-1"
                />
              </div>
            </transition>

            <transition name="fade">
              <img
                :style="control_2"
                v-if="!tours_show"
                src="@/assets/icons/map/Tour Button Closed.svg"
                style="
                  height: 33px;
                  width: auto;
                  z-index: 100;
                  row-gap: 8px;
                  position: absolute;
                  top: 66px;
                  right: 13px;
                  border-radius: 20px;
                  border: 2.5px solid #c5874a;
                "
              />
            </transition>
          </button>
        </div>
      </transition>

      <div
        style="z-index: 100; position: absolute; bottom: 30px; right: 10px"
        class="d-flex flex-column align-end"
      >
        <transition name="fadeInTop">
          <div v-if="!dialog" class="d-flex flex-column mb-2">
            <button style="margin-top: auto">
              <img
                src="@/assets/icons/map/North Button.svg"
                style="height: 35px; width: auto"
              />
            </button>
            <button @click="recenter">
              <img
                src="@/assets/icons/map/Location Button.svg"
                style="height: 35px; width: auto"
              />
            </button>
          </div>
        </transition>
        <transition name="fade">
          <button v-if="!dialog" @click="openDialog">
            <div
              class="primary white--text d-flex align-center justify-space-between"
              style="
                text-align: center;
                height: 35px;
                width: auto;
                z-index: 100;
                border-radius: 18px;
                font-size: 16px;
              "
            >
              <span class="pl-4 mr-10"> {{ $t("buttons.list") }} </span>

              <img
                src="@/assets/icons/map/List Button_closed.png"
                style="width: auto; height: 24px"
                class="mr-1"
              />
            </div>
          </button>
        </transition>
      </div>
      <transition name="fade">
        <div
          v-if="dialog"
          style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh"
        >
          <ListDialog
            :tours="tours"
            @close="closeDialog"
            v-if="dialog"
          ></ListDialog>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import mapStyles from "../../utils/mapStyles.json";
import GmapCustomMarker from "vue2-gmap-custom-marker";
import { mapActions, mapMutations, mapState } from "vuex";
import ListDialog from "@/components/Dialogs/ListDialog.vue";

export default {
  components: {
    ListDialog,
    "gmap-custom-marker": GmapCustomMarker,
  },

  async created() {
    this.setMenuIconColor("blue");

    // latitude: 40.31037,
    //       longitude: 23.06305,
    axios.defaults.headers.common[
      "Accept-Language"
    ] = `${this.mobileLang.code}`;
    await this.getTours();
    this.loader = false;
    await this.getLocation();
  },

  mounted() {
    this.$nextTick(() => {
      this.map = this.$refs.mapRef;
    });
  },

  data() {
    return {
      loader: true,
      dialog: false,
      map: null,
      mapOptions: {
        directionsService: null,
        directionsRenderer: null,
        zoomControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        streetViewControl: false,
        keyboardShortcuts: false,
        gestureHandling: "greedy",

        minZoom: 8,
        maxZoom: 15,

        styles: mapStyles,
      },

      tours_show: true,
      colonies_show: true,
    };
  },

  computed: {
    google: gmapApi,

    ...mapState({
      insets: (state) => state.base.insets,
      location: (state) => state.base.location,
      tours: (state) => state.routes.tours,
      mobileLang: (state) => state.base.mobileLang,
    }),

    main() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 0px)`;
    },

    control_1() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 80px)`;
    },

    control_2() {
      return `top: calc(${
        this.insets?.top ? this.insets?.top + "px" : "0px"
      } + 130px)`;
    },
  },

  methods: {
    ...mapMutations(["setCurrentTour", "setMenuIconColor"]),
    ...mapActions(["getLocation", "getTours"]),

    openDialog() {
      this.setMenuIconColor("white");
      this.dialog = true;
    },

    closeDialog() {
      this.setMenuIconColor("blue");

      this.dialog = false;
    },

    async recenter() {
      try {
        this.$refs.mapRef.panTo({
          lat: this.location.latitude,
          lng: this.location.longitude,
        });
      } catch (e) {
        console.log(e);
      }
    },

    onTourClick(tour) {
      this.$router.push(`/tour/${tour.id}`);
    },

    GetCurrentCenter(event) {
      console.log("latitude: " + event.lat());
      console.log("longitude: " + event.lng());
    },
    GetCurrentZoom(event) {
      console.log(event);
    },

    toggleColonies() {
      this.colonies_show = !this.colonies_show;
    },

    toggleTours() {
      this.tours_show = !this.tours_show;
    },
  },
};
</script>

<style scoped lang="scss">
#return-button {
  position: absolute;
  top: 20px;
  left: 10px;
}

#map-controls {
  position: absolute;
  top: 20px;
  right: 10px;
}

.googleMap {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
}

@keyframes fadeOutRight {
  from {
    transform: translate3d(0, 0, 0);

    opacity: 1;
  }

  to {
    transform: translate3d(170px, 0, 0);

    opacity: 0;
  }
}

@keyframes fadeInLeft {
  from {
    transform: translate3d(170px, 0, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

@keyframes fadeOutBottom {
  from {
    transform: translate3d(0, -50px, 0);
    opacity: 1;
  }

  to {
    transform: translate3d(0, 1px, 0);

    opacity: 0;
  }
}

@keyframes fadeInTop {
  from {
    transform: translate3d(0, 30px, 0);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
}

.fadeInLeft-enter-active {
  animation: fadeInLeft 0.5s ease;
}
.fadeInLeft-leave-to {
  animation: fadeOutRight 0.5s ease;
}

.fadeInTop-enter-active {
  animation: fadeInTop 0.5s ease;
}
.fadeInTop-leave-to {
  z-index: 0;
  animation: fadeOutBottom 0.5s ease;
}
</style>
